const LINKS_KEY = "graphiql:collections:tab-links";
function isTabLink(value) {
  return typeof value === "object" && value !== null && typeof value.collectionId === "string" && typeof value.itemId === "string";
}
function loadTabLinks() {
  try {
    const raw = localStorage.getItem(LINKS_KEY);
    if (!raw) {
      return {};
    }
    const parsed = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null) {
      return {};
    }
    const links = {};
    for (const [tabId, link] of Object.entries(parsed)) {
      if (isTabLink(link)) {
        links[tabId] = link;
      }
    }
    return links;
  } catch {
    return {};
  }
}
function saveTabLinks(links) {
  try {
    localStorage.setItem(LINKS_KEY, JSON.stringify(links));
  } catch {
  }
}
export {
  loadTabLinks,
  saveTabLinks
};
//# sourceMappingURL=tab-links.js.map
